import api from '../api';

const getDefaultState = () => ({
    carriers: [],
    simcards: [],
});

export const act = {
    namespaced: true,

    state: getDefaultState(),

    mutations: {
        setCarriers(state, carriers) {
            state.carriers = carriers;
        },
        setSimcards(state, simcards) {
            state.simcards = simcards;
        },
        resetState(state) {
            Object.assign(state, getDefaultState());
        },
    },

    getters: {

        preliminaryWorkIsReady(state) {
            return state.carriers.length > 0;
        },

        carrierNameMap(state) {
            return state.carriers.reduce((map, carrier) => {
                map[carrier.id] = carrier.name;
                return map;
            }, {});
        },

    },

    actions: {

        reset({ commit }) {
            commit('setCarriers', []);
            commit('setSimcards', []);
        },

        fetchCarriers({ commit }) {

            api.getCarriers()
                .then(
                    res => {
                        let carriers = res.data.data;
                        carriers.sort(function(e1, e2) {
                            switch (true) {
                                case e1.name < e2.name:
                                    return -1;
                                case e1.name > e2.name:
                                    return 1;
                                default:
                                    return 0;
                            }
                        })
                        commit('setCarriers', carriers);
                    }
                )
        },

        activateSimcards({ state, commit }) {
            return api.activateSimcards(state.simcards)
                .then(
                    res => {
                        console.log(res);
                        commit('setSimcards', []);
                    }
                )
        }

    }

};